<template>
	<ui-dialog :title="$t('move_customer.title')" @submit="onSubmit" @close="onClose" defaultSlotContainerClassNames="CustomerTree__container" class="customer-move-dialog">
		<template #nonWrappedBody>
			<div class="px-4 pt-4" v-if="$isAllowedTo('tree_move_level_globally')">
				<CompanyDropdown @on-select="onSelectCompany" is-move :value="selectedCompany" />
			</div>
		</template>

		<CustomerTree :items="customers" is-move @on-select="onSelectCustomer" :selected-id="selectedCustomer?.id" :disabled-ids="getDisabledIds"/>

		<template #actions>
			<div class="is-flex is-justify-content-space-between">
				<div class="is-flex is-align-items-center">
					<ui-alert v-if="error" error>{{ error }}</ui-alert>
					<ui-alert v-if="successMessage" success>{{ successMessage }}</ui-alert>
				</div>
				<ui-btn class="is-info" :loading="isPending" type="submit" icon="fa-save" :disabled="customers.length < 1">{{ $t('move_customer.move_button') }}</ui-btn>
			</div>
		</template>
	</ui-dialog>
</template>

<script>
import CompanyDropdown from '@/components/company/company-dropdown';
import CustomerTree from '@/components/customer/customer-tree';

import { mapGetters, mapActions } from 'vuex';

export default {
	components: {
		CompanyDropdown,
		CustomerTree
	},

	props: {

	},

	data: () => ({
		selectedCompany: null,
		selectedCustomer: null,
		customers: [],

		error: '',
		successMessage: '',
		isPending: false
	}),

	computed: {
		...mapGetters('user', ['getUser', 'getActiveCustomer', 'getActiveCompany']),

		getDisabledIds() {
			const targetCustomerObj = this.$utils.tree.findById(this.customers, this.getActiveCustomer.id);

			if (!targetCustomerObj) {
				return [];
			}

			return this.$utils.tree.toFlat([targetCustomerObj]).map(x => x.id);
		}
	},

	created() {
		this.selectedCompany = {...this.getActiveCompany};
		this.fetchTree();
	},

	methods: {
		...mapActions('user', ['setActiveCustomer']),

		onSelectCompany(company) {
			this.selectedCompany = company;
			this.fetchTree();
		},

		onSelectCustomer(customer) {
			this.selectedCustomer = customer;
		},

		async onSubmit() {
			this.error = '';
			this.successMessage = '';

			const targetCustomerObj = this.$utils.tree.findById(this.customers, this.selectedCustomer.id);

			const targetIsChild = this.$utils.tree.toFlat([targetCustomerObj]).some(x => x.id === this.getActiveCustomer.id);

			if (targetIsChild) {
				this.error = this.$t('move_customer.error_cannot_move_self');

				return;
			}

			try {
				await this.$services.customer.move({
					id: this.getActiveCustomer.id,
					parentId: this.selectedCustomer?.id,
					companyId: this.selectedCompany.id
				});

				this.successMessage = this.$t('move_customer.success');
				this.fetchTree();

				this.setActiveCustomer(this.getUser.customer);

				this.$emit('on-update');
			} catch (error) {
				this.error = error.message;
			}
		},

		async fetchTree() {
			this.error = '';
			let rootNode = null;

			if (!this.$isAllowedTo('tree_modify_level')) return;

			if (!this.$isAllowedTo('tree_move_level_within_root')) {
				rootNode = this.getUser.customer;
			} else if (!this.$isAllowedTo('tree_move_level_within_company'))
				rootNode = await this.$services.customer.getRootCustomer({
					customerId: this.getActiveCustomer.id,
					companyId: this.getActiveCompany.id
				}, {
					loading: val => {
						this.isPending = val;
					}
				});

			try {
				this.customers = await this.$services.customer.getTree({
					companyNode: this.selectedCompany.id,
					parentNode: rootNode ? rootNode.id : null
				}, {
					loading: val => {
						this.isPending = val;
					}
				});
			} catch (error) {
				this.error = error.message;
			}
		},

		onClose() {
			this.$emit('close');
		}
	}
};
</script>

<style lang="scss" scoped>
.customer-move-dialog {
	overflow: visible !important;

	.modal-card {
		overflow: visible !important;

		.ui-card {
			height: 100%;

			.ui-form {
				display: flex;
				flex-direction: column;
				height: 100%;
				overflow: visible !important;

				.CustomerTree__container {
					padding-top: 0 !important;
					overflow: hidden !important;

					> .CustomerTree {
						height: 100%;
						overflow-y: scroll;
					}
				}

				.ui-card-actions {
					margin-top: 1rem;
				}
			}
		}

	}
}
</style>
